// extracted by mini-css-extract-plugin
module.exports = {"Dividend":"Dividend_Dividend__OFeBe","bottom-text":"Dividend_bottom-text__kbgIS","value":"Dividend_value__fksu0","overview-page":"Dividend_overview-page__f9VkI"};